import {Token} from "src/pages/AdminPage/AddAndUpdateSaas/dialogs/generic/Token";

export const Smartsheet = () => {
  return <Token label='API Key' />
};
